<template>
  <div id="hrese1e">
    E-Learning
  </div>
</template>

<script>
import { router } from 'src/router'

export default {
  name: 'hrese1e',
  data () {
    return {
      app: this.$parent.$parent.$parent
    }
  },
  created () {
    window.open('/elearning/auth/#store-profile')
    router.push({ name: 'home' })
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?aae62b78